var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRainbowBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 67,
    viewBox: "0 0 135 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3925 20.634C92.8536 20.634 113.494 41.013 113.494 66.1518H101.719C101.719 47.4339 86.3504 32.26 67.3925 32.26C48.4346 32.26 33.0661 47.4339 33.0661 66.1518H21.2911C21.2911 41.013 41.9314 20.634 67.3925 20.634Z",
    fill: "#9D48B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3925 0C104.396 3.19396e-06 134.392 29.6172 134.392 66.1518L122.617 66.1518C122.617 36.038 97.8923 11.626 67.3925 11.626C36.8926 11.626 12.1676 36.038 12.1676 66.1518H0.392578C0.392581 29.6172 30.3895 -3.19396e-06 67.3925 0Z",
    fill: "#9D48B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3925 40.3301C81.8363 40.3301 93.5453 51.8909 93.5453 66.1518H81.7702C81.7702 58.3117 75.3331 51.9561 67.3925 51.9561C59.4519 51.9561 53.0148 58.3117 53.0148 66.1518L41.2397 66.1518C41.2397 51.8909 52.9487 40.3301 67.3925 40.3301Z",
    fill: "#9D48B3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainbowBlue);
export default __webpack_public_path__ + "static/media/rainbow-blue.fc13fb20b42868de9074c52da4daeae1.svg";
export { ForwardRef as ReactComponent };